import React from 'react';
import PropTypes from 'prop-types';
import { CMS } from '../../utils/CMS';
import { QuickAccessOptions } from './QuickAccessOptions';

export const QuickAccess = (props) => {
    const { pax, open, toggle, onChange, numQuickOptions } = props;
    const { adults, kids, infants } = pax;
    const quickAccessValue = !kids && !infants && adults <= numQuickOptions;
    const arrowPosition = open ? 'up' : 'down';
    const openClass = open ? 'open' : '';

    return (
        <div
            className={`odf-grid odf-pax-selector-label wl-bookingcom-input ${openClass}`}
            onClick={toggle}
        >
            <div className="odf-row-fluid odf-row-nogutter odf-pax-selector-label-row">
                <div className="odf-col odf-col-lg odf-col-middle">
                    <div className="odf-text-ellipsis odf-pax-selector-title">
                        <CMS id="paxSelector.adult.pluralForms" value={{ count: adults }} />
                        {/* TODO: create CMS keys for separators */}
                        {!infants && kids ? ' & ' : kids && infants ? ', ' : ''}
                        <CMS id="paxSelector.child.pluralForms" value={{ count: kids }} />
                        {infants ? ' & ' : ''}
                        <CMS id="paxSelector.infant.pluralForms" value={{ count: infants }} />
                    </div>
                </div>
                <div className="odf-col odf-col-middle odf-pax-selector-quick-access">
                    <QuickAccessOptions
                        onChange={(value) => onChange({ adults: value })}
                        value={quickAccessValue}
                    />
                </div>
                <div className="odf-col odf-col-middle odf-pax-selector-arrow">
                    <span
                        className={`odf-icon odf-icon-arrow-${arrowPosition} odf-pax-selector-arrow-icon`}
                    />
                </div>
            </div>
        </div>
    );
};

QuickAccess.propTypes = {
    pax: PropTypes.shape({
        adults: PropTypes.number,
        kids: PropTypes.number,
        infants: PropTypes.number,
    }).isRequired,
    onChange: PropTypes.func.isRequired,
    open: PropTypes.bool.isRequired,
    toggle: PropTypes.func.isRequired,
    numQuickOptions: PropTypes.number,
};

QuickAccess.defaultProps = {
    numQuickOptions: 3,
};
